import { ApplicationConfig, Injectable, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { DIRECTION_ALL } from 'hammerjs';
import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideAnalytics, getAnalytics } from '@angular/fire/analytics';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export function playerFactory() {
  return player;
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  override overrides = <any>{
    'pinch': { enable: true },
    'rotate': { enable: true },
    'pan': { direction: DIRECTION_ALL, threshold: 0 },
    'swipe': { direction: DIRECTION_ALL },
    'tap': { time: 250, threshold: 9 },
    'doubletap': { enable: false }
  };

  override buildHammer(element: HTMLElement): any {
    const mc = new Hammer(element, {
      touchAction: 'auto',
      inputClass: Hammer.TouchInput
    });

    mc.add(new Hammer.Pinch({ enable: true }));
    mc.add(new Hammer.Pan({ direction: DIRECTION_ALL, threshold: 0 }));
    mc.add(new Hammer.Tap());
    mc.add(new Hammer.Tap({ event: 'doubletap', taps: 2 }));

    return mc;
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    Apollo,
    HttpLink,
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
    ),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideAnalytics(() => getAnalytics()),
    { provide: HAMMER_GESTURE_CONFIG, useClass: MyHammerConfig },
    provideLottieOptions({ player: playerFactory }),
  ],
};
